import { ButtonAddHLPure, DialogAddUserPure, GridPure, SearchBarHLPure } from '../../pures'
import { Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useMemo, useState } from 'react'

/**
 * Un usuario sin nombre es alguien que fue invitado pero nunca terminó su onboarding,
 * por lo que es el único caso donde tiene sentido reenviarle el correo de invitación.
 */
const hasUserName = (dataItem) => [dataItem?.firstName, dataItem?.firstLastName, dataItem?.secondLastName]
    .some(part => part && part !== 'undefined' && part !== 'null' && `${part}`.trim() !== '')

const UserAdministrationList = (props) => {
    // #region variables
    const {
        t,
        users,
        roles,
        createNewUser,
        updateUserStatus,
        resendUserInvitation,
        setSelectedUser,
        clientAssistants,
        loadingClientAssistants
    } = props

    const { t: tCommon } = useTranslation('common')

    const [searchUser, setSearchUser] = useState('')
    const [showAddUserDialog, setShowAddUserDialog] = useState(false)
    // #endregion variables

    // #region effects
    const usersTransformed = useMemo(() => {
        return users.map(v => ({
            ...v,
            status: v.status === 'active' ? t('statusEnabled') : t('statusDisabled')
        }))
    }, [users, t])

    const userGrid = useMemo(() => {
        if (!searchUser) return usersTransformed;

        const lowercasedSearchUser = searchUser.toLowerCase()
        const filteredUsers = usersTransformed.filter(el => el.name.toLowerCase().includes(lowercasedSearchUser) ||
            el.email.includes(lowercasedSearchUser))
        return filteredUsers
    }, [usersTransformed, searchUser])

    // Roles generales (usuario / administrador) disponibles al invitar a alguien
    const roleOptions = useMemo(() => {
        const generalGroup = (roles || []).find(group => group.groupName === 'general')
        return (generalGroup?.roles || []).map(role => ({ id: role.id, label: t(role.key) }))
    }, [roles, t])
    // #endregion effects

    // #region methods
    const handleChangeSearch = (e) => setSearchUser(e.target.value);

    const handleCreateUser = async ({ email, roleId, assistantIds }) => {
        await createNewUser(email, roleId, assistantIds)
    }
    // #endregion methods

    return (
        <>
            <Grid item xs={12} className="add-and-search-container">
                <ButtonAddHLPure
                    iconAdd={true}
                    nameBtn={t("addUser")}
                    onClickBtn={() => setShowAddUserDialog(true)}
                />
                <SearchBarHLPure
                    placeholder={tCommon("search")}
                    onSearchChange={((e) => handleChangeSearch(e))}
                />
            </Grid>
            <Grid item xs={12}>
                <GridPure
                    {...props}
                    dataGrid={userGrid}
                    skip={0}
                    take={11}
                    rowsItems={[
                        {
                            field: 'name',
                            title: t('users'),
                            width: '34%',
                            sorteable: true
                        },
                        {
                            field: 'email',
                            title: tCommon("mail"),
                            width: '22%',
                            sorteable: true
                        },
                        {
                            field: 'status',
                            title: t('status'),
                            width: '12%',
                            sorteable: true
                        },
                        {
                            // Necesita ~330px para los tres botones, por eso es la más ancha
                            field: 'Acciones',
                            title: tCommon('actions'),
                            width: '30%',
                            actions: true
                        }]}
                    actionsAlign='left'
                    actions={[
                        {
                            type: 'view-details',
                            value: tCommon('details'),
                            onClick: (dataItem) => {
                                setSelectedUser(dataItem)
                            }
                        },
                        {
                            type: 'label',
                            // Ancho fijo para que las acciones siguientes queden alineadas entre filas
                            className: 'userAdministration-statusActionBtn',
                            value: (dataItem) => dataItem.active ? t('disable') : t('enable'),
                            onClick: (dataItem) => {
                                updateUserStatus(!dataItem.active, dataItem.email)
                            }
                        },
                        {
                            type: 'label',
                            value: t('resendInvitation'),
                            visible: (dataItem) => !hasUserName(dataItem),
                            onClick: (dataItem) => {
                                resendUserInvitation(dataItem.email)
                            }
                        },
                    ]}
                />
            </Grid>

            {showAddUserDialog && (
                <DialogAddUserPure
                    onClose={() => setShowAddUserDialog(false)}
                    onSubmit={handleCreateUser}
                    roleOptions={roleOptions}
                    assistants={clientAssistants || []}
                    loadingAssistants={loadingClientAssistants}
                />
            )}
        </>
    )
}

export default UserAdministrationList